import { render, staticRenderFns } from "./DialogCreateExpenseConfig.vue?vue&type=template&id=58ffbcfa&scoped=true&"
import script from "./DialogCreateExpenseConfig.vue?vue&type=script&lang=js&"
export * from "./DialogCreateExpenseConfig.vue?vue&type=script&lang=js&"
import style0 from "./DialogCreateExpenseConfig.vue?vue&type=style&index=0&id=58ffbcfa&lang=scss&scoped=true&"
import style1 from "./DialogCreateExpenseConfig.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./DialogCreateExpenseConfig.vue?vue&type=style&index=2&id=58ffbcfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ffbcfa",
  null
  
)

export default component.exports